import React, { useState, useEffect } from 'react';

const ContactEmail: React.FC = () => {
  const [email, setEmail] = useState('');
  const [originalEmail, setOriginalEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchEmail();
  }, []);

  const fetchEmail = async () => {
    try {
      const response = await fetch('/api/content/contact_email', {
        credentials: 'include',
      });
      const data = await response.json();
      setEmail(data.value || 'lead@aiaccessconsulting.com');
      setOriginalEmail(data.value || 'lead@aiaccessconsulting.com');
    } catch (err) {
      setError('Failed to load contact email');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setMessage('');
    setError('');

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setSaving(true);

    try {
      const response = await fetch('/api/content/contact_email', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ value: email }),
      });

      if (!response.ok) {
        throw new Error('Failed to save');
      }

      setMessage('Contact email saved successfully!');
      setOriginalEmail(email);
    } catch (err) {
      setError('Failed to save contact email. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const hasChanges = email !== originalEmail;

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="window" style={{ maxWidth: '600px' }}>
      <div className="title-bar">
        <div className="title-bar-text">Contact Email</div>
      </div>
      <div className="window-body" style={{ padding: '16px' }}>
        <p style={{ marginBottom: '16px', fontSize: '11px' }}>
          This email address will be used when visitors click the Contact icon on the desktop.
          It will open their default email client with this address in the "To:" field.
        </p>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '4px', fontSize: '11px' }}>
            Contact Email Address:
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="email@example.com"
            style={{ width: '100%', padding: '4px' }}
          />
        </div>

        {message && (
          <div style={{
            background: '#008000',
            color: '#fff',
            padding: '8px',
            marginBottom: '12px',
            fontSize: '11px'
          }}>
            {message}
          </div>
        )}

        {error && (
          <div style={{
            background: '#ff0000',
            color: '#fff',
            padding: '8px',
            marginBottom: '12px',
            fontSize: '11px'
          }}>
            {error}
          </div>
        )}

        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            onClick={handleSave}
            disabled={!hasChanges || saving}
          >
            {saving ? 'Saving...' : 'Save'}
          </button>
          {hasChanges && (
            <button
              onClick={() => setEmail(originalEmail)}
              disabled={saving}
            >
              Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactEmail;
